import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { SubmissionService } from '../../services/submission.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const subtasks = writable([]);
export const stats = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "-createdOn" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    //stats.set(null);
    fetchSubmission(oid);
    loadSubmissionSubtasks(oid);
    //let _resp = await SubmissionService.fetchSubmission(oid);
    //record.set(_resp.payload);
    //await loadStats(oid);
}
export async function fetchSubmission(submissionId) {
    let _resp = await SubmissionService.fetchSubmission(submissionId);
    record.set(_resp.payload);
}
export async function loadSubmissionSubtasks(submissionId) {
    loading.set(true);
    try {
        //let _filter = <ISearchFilterDTO<ISubmission>>({ criteria: <ISubmission>{ oid: submissionId }, params: null, sorting: "" });
        //let _pag = get(pagination);
        // let _pag: IApiPagination = { currentPage: 1, totalPages: 0, totalRecords: 0 };
        let _resp = await SubmissionService.getSubmissionSubtasks(submissionId);
        subtasks.set(_resp.payload);
        //pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
async function loadStats(_submissionId) {
    //let _resp = await ClassroomService.fetchClassroomStats(classroomOid);
    //stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await SubmissionService.getSubmissions(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    // CANNOT CREATE
    //navigate(`/submission/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/submission/${item.oid}`);
}
export async function save() {
    // CANNOT SAVE
    //let _record = get(record);
    //return await SubmissionService.saveSubmission(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await SubmissionService.deleteSubmission(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
